import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Pro Light Icons
 */
import {
  faHomeLgAlt, faUsers, faClipboardListCheck, faFileChartLine, faCity, faIdCard, faUserCircle,
  faEnvelope, faCircleNotch, faInfoCircle, faMagic, faSearch, faCalendarAlt as falCalendarAlt,
  faCog, faEye, faPencil
} from '@fortawesome/pro-light-svg-icons'

/**
 * Pro Regular Icons
 */
import {
  faQuestionCircle, faSignOut, faCalendarAlt, faPlus, faTrash, faFileImport, faBallotCheck, faUser, faCheck as farCheck, faTimes as farTimes,
  faUserFriends, faCheckSquare, faCogs, faInfoCircle as farInfoCircle, faRetweetAlt, faTrashAlt, faPencil as farPencil, faFileUpload, faArchive,
  faCloudDownload, faFileSpreadsheet, faFileArchive
} from '@fortawesome/pro-regular-svg-icons'

/**
 * Pro Solid Icons
 */
import {
  faCheck, faTimes, faChevronDown
} from '@fortawesome/pro-solid-svg-icons'

library.add(
  faHomeLgAlt, faUsers, faClipboardListCheck, faFileChartLine, faCity, faIdCard, faUserCircle,
  faEnvelope, faCircleNotch, faInfoCircle, faMagic, faQuestionCircle, faSignOut, faCalendarAlt,
  faPlus, faTrash, faSearch, faFileImport, faCheck, faTimes, faBallotCheck, faUser, farCheck, farTimes,
  falCalendarAlt, faUserFriends, faCheckSquare, faCogs, faChevronDown, faCog, farInfoCircle,
  faRetweetAlt, faTrashAlt, faEye, faPencil, farPencil, faFileUpload, faArchive, faCloudDownload,
  faFileSpreadsheet, faFileArchive
)

Vue.component('font-awesome', FontAwesomeIcon)
